import Storage from "./local-storage"

export const logout = () => {
    const storage = new Storage()
    storage.clear()
    window.location.href = "/sign-in"
}